import type { ReactNode } from "react";
import React, { createContext, useContext } from "react";

import type {
  CustomDimensions,
  CustomDimensionsOrParams,
  CustomParams,
  SetCustomDimensionOrParam,
} from "../integration/frontend-tracking-agent";

export interface CustomDimensionsRepository {
  getAllParams: () => CustomParams;
  getAll: () => CustomDimensions;
  update: (customDimensions: Partial<CustomDimensionsOrParams>) => void;
  set: (params: SetCustomDimensionOrParam) => void;
}

interface CustomDimensionsProviderProps {
  customDimensionsRepository: CustomDimensionsRepository;
  children: ReactNode;
}

const defaultCustomDimensionsContext = {
  getAll: () => ({}),
  getAllParams: () => ({}),
  update: () => {},
  set: () => {},
};

const customDimensionsContext = createContext<CustomDimensionsRepository>(
  defaultCustomDimensionsContext,
);

export const useCustomDimensions = () => useContext(customDimensionsContext);

export const CustomDimensionsProvider = ({
  customDimensionsRepository,
  children,
}: CustomDimensionsProviderProps) => (
  <customDimensionsContext.Provider value={customDimensionsRepository}>
    {children}
  </customDimensionsContext.Provider>
);
